import React, { Component } from 'react';
import NewsTicker from '../../components/ticker';
import MyDelfi from '../../components/mydelfi';
import Events from '../../components/events';
import withAuthProvider from '../../hoc/withAuthProvider';
import { REACT_APP_API_BASE } from '../../config';
import withFetch from '../../hoc/withFetch';

class Start extends Component {
    
    state = {
        isLoading: true,
        isLoadingNews: true,
        data: null,
        news: null
    };

    async componentDidUpdate() {
        if (!this.props.isAuthenticated) return;

        if (this.state.data) return;

        const res = await this.props.fetch(`${REACT_APP_API_BASE}/online/startpage`);
        const data = await res.json();
        const { news } = data.news;
        this.setState({
            isLoading: false,
            isLoadingNews: false,
            data,
            news
        });
    }
    
    render() {
        return (
            <section className="start">
               <NewsTicker isLoading={this.state.isLoadingNews} news={this.state.news} />
               <MyDelfi {...this.state.data} isLoading={this.state.isLoading} />
               <Events {...this.state.data} 
                       isLoading={this.state.isLoading} 
                       isLoadingNews={this.state.isLoadingNews}
                       news={this.state.news} 
                       fetch={this.props.fetch} 
                       location={this.props.location} />
            </section>
        );
    }
};

export default withAuthProvider(withFetch(Start));